module.exports = {
  "/": {
    "name": "reroutes-indexPage"
  },
  "/view/*": {
    "name": "indexPage"
  },
  "/folders": {
    "name": "indexPageFolders"
  },
  "/details/*": {
    "name": "detailsPage"
  },
  "/platform/create": {
    "name": "createPage"
  },
  "/templates": {
    "name": "templatesPage"
  },
  "/flow/:workflowId": {
    "name": "reroutes-editFlowPage",
    "success": {
      "Classic flow redirect loaded": [
        "PLATFORM_FLOW_ID_IN_CLASSIC_FLOW_REDIRECT"
      ]
    },
    "error": [
      "WORKFLOW_NOT_FOUND"
    ]
  },
  "/flow/:workflowId/*": {
    "name": "reroutes-editFlowPage1",
    "error": [
      "WORKFLOW_NOT_FOUND"
    ]
  },
  "/platform/create/*": {
    "name": "createFlowPage"
  },
  "/create": {
    "name": "createCanvasPage",
    "success": {
      "Create page loaded": [
        "FLOW_CREATE_CONTAINER"
      ]
    }
  },
  "/platform/flow/:flowId": {
    "name": "reroutes-editFlowPage2"
  },
  "/platform/flow/:flowId/settings": {
    "name": "settings",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Flow settings loaded": [
        "SETTINGS_SIDEBAR"
      ]
    }
  },
  "/platform/flow/:flowId/edit": {
    "name": "editFlowPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Flow canvas loaded": [
        "FLOW_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/edit/actions/enrollment": {
    "name": "reroutes-enrollmentFiltersPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ]
    }
  },
  "/platform/flow/:flowId/edit/actions/enrollment/filters": {
    "name": "enrollmentFiltersPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Enrollment filters loaded": [
        "FLOW_CONFIGS_CONTAINER",
        "ACTION_CONFIG_ENROLLMENT_FILTER_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/actions/enrollment/filters/reenrollment": {
    "name": "reenrollmentPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Reenrollment config loaded": [
        "FLOW_CONFIGS_CONTAINER",
        "ACTION_CONFIG_REENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/actions/enrollment/filters/unenrollment": {
    "name": "unenrollmentFiltersPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Unenrollment config loaded": [
        "ACTION_CONFIG_UNENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/triggers/event": {
    "name": "eventEnrollmentPage"
  },
  "/platform/flow/:flowId/edit/triggers/event/enrollment": {
    "name": "eventTriggersEnrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Enrollment filters loaded": [
        "EVENT_ENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/triggers/event/reenrollment": {
    "name": "eventTriggersReenrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Reenrollment config loaded": [
        "EVENT_ENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/triggers/event/unenrollment": {
    "name": "eventTriggersUnenrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Unenrollment config loaded": [
        "ACTION_CONFIG_UNENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/triggers": {
    "name": "triggerSelectionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Enrollment filters loaded": [
        "TRIGGER_SELECTION_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/triggers/unenrollment": {
    "name": "manualTriggerUnenrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Enrollment filters loaded": [
        "TRIGGER_SELECTION_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/triggers/reenrollment": {
    "name": "manualTriggerReenrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Enrollment filters loaded": [
        "TRIGGER_SELECTION_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/triggers/scheduled": {
    "name": "triggersScheduledEnrollmentRoot"
  },
  "/platform/flow/:flowId/edit/triggers/scheduled/enrollment": {
    "name": "triggersScheduledEnrollmentPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Enrollment filters loaded": [
        "SCHEDULED_ENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/triggers/scheduled/reenrollment": {
    "name": "triggersScheduledReEnrollmentPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Re-Enrollment filters loaded": [
        "SCHEDULED_RE_ENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/triggers/scheduled/unenrollment": {
    "name": "scheduledTriggersUnenrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Unenrollment config loaded": [
        "ACTION_CONFIG_UNENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/actions/enrollment/template/filters": {
    "name": "enrollmentTemplateFiltersPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Template enrollment filters loaded": [
        "TEMPLATE_ENROLLMENT_FILTER_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/enrollment-checks": {
    "name": "enrollmentChecks"
  },
  "/platform/flow/:flowId/edit/actions/new-action": {
    "name": "viewNewActionsPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "New action config loaded": [
        "FLOW_CONFIGS_CONTAINER"
      ]
    }
  },
  "/platform/flow/:flowId/edit/actions/new-action/:actionType": {
    "name": "addNewActionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "New action config loaded": [
        "FLOW_CONFIGS_CONTAINER"
      ]
    }
  },
  "/platform/flow/:flowId/edit/action-set/:actionSetId": {
    "name": "actionSetConfigPanel",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Action set config panel loaded": [
        "ACTION_SET_CONFIG_PANEL"
      ]
    },
    "error": [
      "ACTION_SET_CONFIG_PANEL_FAILED"
    ]
  },
  "/platform/flow/:flowId/edit/actions/:actionId/email/editor": {
    "name": "emailEditorPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Email editor loaded": [
        "ACTION_CONFIG_PANEL",
        "FLOW_CONFIGS_CONTAINER",
        "FLOW_CONFIGS_EMAIL_EDITOR"
      ]
    }
  },
  "/platform/flow/:flowId/edit/actions/:actionId/email/editor/:emailId": {
    "name": "emailEditorPage2",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Email editor loaded": [
        "ACTION_CONFIG_PANEL",
        "FLOW_CONFIGS_CONTAINER",
        "FLOW_CONFIGS_EMAIL_EDITOR"
      ]
    }
  },
  "/platform/flow/:flowId/edit/actions/:actionId": {
    "name": "reroutes-editActionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ]
    }
  },
  "/platform/flow/:flowId/edit/actions/:actionId/:actionType": {
    "name": "editActionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Edit action config loaded": [
        "FLOW_CONFIGS_CONTAINER",
        "ACTION_CONFIG_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/go-to-edit/:actionId": {
    "name": "editGoToActionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Go-to edit canvas loaded": [
        "GO_TO_EDIT_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/edit/optimize": {
    "name": "optimizePage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Go-to edit canvas loaded": [
        "OPTIMIZATION_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/edit/data-source-edit/:actionId": {
    "name": "editDataSourcePage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "data source edit canvas loaded": [
        "DATA_SOURCE_EDIT_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/edit/move-action/:actionId": {
    "name": "moveActionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Move edit canvas loaded": [
        "MOVE_ACTION_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/edit/test-flow": {
    "name": "testFlowPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Test flow loaded": [
        "FLOW_CANVAS",
        "TEST_FLOW"
      ]
    }
  },
  "/platform/flow/:flowId/edit/test-flow/:objectId": {
    "name": "testFlowPage2",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Test flow loaded": [
        "FLOW_CANVAS",
        "TEST_FLOW"
      ]
    }
  },
  "/platform/flow/:flowId/edit/ai-assistant": {
    "name": "aiAssistant",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "AI assistant panel loaded": [
        "AI_ASSISTANT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/ai-assistant/:assetType": {
    "name": "aiAssistantAsset",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "AI assistant panel loaded": [
        "AI_ASSISTANT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/edit/ai-assistant/:assetType/generate": {
    "name": "aiAssistantGenerateAsset",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "AI assistant panel loaded": [
        "AI_ASSISTANT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/action-set": {
    "name": "editActionSetPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Flow canvas loaded": [
        "FLOW_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/action-set/actions/new-action": {
    "name": "actionSetViewNewActionsPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "New action config loaded": [
        "FLOW_CONFIGS_CONTAINER"
      ]
    }
  },
  "/platform/flow/:flowId/action-set/actions/new-action/:actionType": {
    "name": "actionSetAddNewActionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "New action config loaded": [
        "FLOW_CONFIGS_CONTAINER"
      ]
    }
  },
  "/platform/flow/:flowId/action-set/actions/:actionId/email/editor": {
    "name": "actionSetEmailEditorPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Email editor loaded": [
        "ACTION_CONFIG_PANEL",
        "FLOW_CONFIGS_CONTAINER",
        "FLOW_CONFIGS_EMAIL_EDITOR"
      ]
    }
  },
  "/platform/flow/:flowId/action-set/actions/:actionId/email/editor/:emailId": {
    "name": "actionSetEmailEditorPage2",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Email editor loaded": [
        "ACTION_CONFIG_PANEL",
        "FLOW_CONFIGS_CONTAINER",
        "FLOW_CONFIGS_EMAIL_EDITOR"
      ]
    }
  },
  "/platform/flow/:flowId/action-set/actions/:actionId": {
    "name": "actionSetReroutes-editActionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ]
    }
  },
  "/platform/flow/:flowId/action-set/actions/:actionId/:actionType": {
    "name": "actionSetEditActionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Edit action config loaded": [
        "FLOW_CONFIGS_CONTAINER",
        "ACTION_CONFIG_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/action-set/go-to-edit/:actionId": {
    "name": "actionSetEditGoToActionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Go-to edit canvas loaded": [
        "GO_TO_EDIT_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/action-set/data-source-edit/:actionId": {
    "name": "actionSetEditDataSourcePage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "data source edit canvas loaded": [
        "DATA_SOURCE_EDIT_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/action-set/move-action/:actionId": {
    "name": "actionSetMoveActionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Move edit canvas loaded": [
        "MOVE_ACTION_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/history": {
    "name": "reroutes-changesPage"
  },
  "/platform/flow/:flowId/history/audit-events": {
    "name": "reroutes-changesPage1"
  },
  "/platform/flow/:flowId/history/audit-events/revisions/:fromVersion/to/:toVersion": {
    "name": "reroutes-revisionsVersionPage"
  },
  "/platform/flow/:flowId/changes": {
    "name": "changesPage",
    "success": {
      "Audit history revision list table loaded": [
        "REVISION_ROLLUP_PANEL_LOADED"
      ]
    },
    "error": [
      "AUDIT_HISTORY_REVISION_LIST_TABLE_FAILED"
    ]
  },
  "/platform/flow/:flowId/changes/revisions/:fromVersion/to/:toVersion": {
    "name": "revisionsVersionPage",
    "success": {
      "Audit history revision list table loaded": [
        "REVISION_ROLLUP_PANEL_LOADED",
        "AUDIT_HISTORY_REVISION_LIST_TABLE_LOADED"
      ]
    },
    "error": [
      "AUDIT_HISTORY_REVISION_LIST_TABLE_FAILED"
    ]
  },
  "/platform/flow/:flowId/history/log-events": {
    "name": "reroutes-actionLogs"
  },
  "/platform/flow/:flowId/history/log-events/event/:logEventId/:timestamp/:tab": {
    "name": "reroutes-actionLogs1"
  },
  "/platform/flow/:flowId/history/enrollments": {
    "name": "enrollmentHistoryPage"
  },
  "/platform/flow/:flowId/history/enrollments/enrollment-details/:enrollmentId/:objectId": {
    "name": "enrollmentDetailsPage"
  },
  "/platform/flow/:flowId/performance": {
    "name": "reroutes-goalsPage"
  },
  "/platform/flow/:flowId/goals": {
    "name": "goalsPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Flow goals loaded": [
        "WORKFLOW_GOALS"
      ]
    }
  },
  "/platform/flow/:flowId/review": {
    "name": "reviewPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Flow review loaded": [
        "FLOW_REVIEW"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview": {
    "name": "reroutes-changesRollupPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview canvas loaded": [
        "REVISION_PREVIEW_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit": {
    "name": "revisionPreviewEditPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview canvas loaded": [
        "REVISION_PREVIEW_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/actions/enrollment": {
    "name": "reroutes-revisionPreviewEnrollmentFiltersPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/actions/enrollment/filters": {
    "name": "revisionPreviewEnrollmentFiltersPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview enrollment panel loaded": [
        "ACTION_CONFIG_ENROLLMENT_FILTER_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/actions/enrollment/filters/reenrollment": {
    "name": "revisionPreviewReenrollmentFiltersPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview reenrollment panel loaded": [
        "ACTION_CONFIG_REENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/actions/enrollment/filters/unenrollment": {
    "name": "revisionPreviewUnenrollmentFiltersPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview unenrollment panel loaded": [
        "ACTION_CONFIG_UNENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/actions/:actionId/:actionType": {
    "name": "revisionsPreviewEditActionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview action config loaded": [
        "REVISION_PREVIEW_CANVAS",
        "ACTION_CONFIG_PANEL",
        "FLOW_CONFIGS_CONTAINER"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers": {
    "name": "revisionsPreviewEditTriggersSelectionPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview action config loaded": [
        "REVISION_PREVIEW_CANVAS",
        "TRIGGER_SELECTION_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers/event": {
    "name": "revisionsPreviewEditEventTriggers"
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers/event/enrollment": {
    "name": "revisionsPreviewEditEventTriggersEnrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview action config loaded": [
        "REVISION_PREVIEW_CANVAS",
        "EVENT_ENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers/event/reenrollment": {
    "name": "revisionsPreviewEditEventTriggersReenrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview action config loaded": [
        "REVISION_PREVIEW_CANVAS",
        "EVENT_ENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers/event/unenrollment": {
    "name": "revisionsPreviewEditEventTriggersUnenrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview action config loaded": [
        "REVISION_PREVIEW_CANVAS",
        "ACTION_CONFIG_UNENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers/scheduled": {
    "name": "revisionsPreviewEditScheduledTriggersEnrollmentRoot"
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers/scheduled/enrollment": {
    "name": "revisionsPreviewEditScheduledTriggersEnrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview action config loaded": [
        "REVISION_PREVIEW_CANVAS",
        "SCHEDULED_ENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers/scheduled/reenrollment": {
    "name": "revisionsPreviewEditScheduledTriggersReEnrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview action config loaded": [
        "REVISION_PREVIEW_CANVAS",
        "SCHEDULED_RE_ENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/revision/:revisionId/preview/edit/triggers/scheduled/unenrollment": {
    "name": "revisionsPreviewEditScheduledTriggersUnenrollment",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Revision preview action config loaded": [
        "REVISION_PREVIEW_CANVAS",
        "ACTION_CONFIG_UNENROLLMENT_PANEL"
      ]
    }
  },
  "/platform/flow/:flowId/enrollment-history": {
    "name": "enrollmentHistory",
    "success": {
      "Enrollment History list page loaded": [
        "ENROLLMENT_HISTORY_LIST_CANVAS"
      ],
      "Enrollment History selected enrollment loaded": [
        "ENROLLMENT_HISTORY_SELECTED_ENROLLMENT"
      ]
    }
  },
  "/platform/flow/:flowId/enrollment-history/*": {
    "name": "enrollmentHistorySubScreen",
    "success": {
      "Enrollment History list page loaded": [
        "ENROLLMENT_HISTORY_LIST_CANVAS"
      ],
      "Enrollment History selected enrollment loaded": [
        "ENROLLMENT_HISTORY_SELECTED_ENROLLMENT"
      ]
    }
  },
  "/platform/flow/:flowId/metrics": {
    "name": "metrics",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Metrics page loaded": [
        "ENROLLMENT_CONVERSION_CANVAS"
      ]
    }
  },
  "/platform/flow/:flowId/aggregate-performance": {
    "name": "reroutes-metrics"
  },
  "/platform/flow/:flowId/view/test-flow": {
    "name": "testFlowView",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Test flow view loaded": [
        "TEST_FLOW"
      ]
    }
  },
  "/embedded-canvas-multi": {
    "name": "unused-embedCanvasMulti",
    "success": {
      "default": [
        "MULTI_FLOW_CONTAINER"
      ]
    }
  },
  "/embedded-contextual-automation-flow": {
    "name": "unused-embedCanvas",
    "success": {
      "default": [
        "CONTEXTUAL_AUTOMATION_CONTAINER"
      ]
    },
    "error": [
      "CONTEXTUAL_AUTOMATION_CONTAINER_ERROR"
    ]
  },
  "/embedded-configs/:flowId/actions/enrollment": {
    "name": "unused-embedEnrollmentPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ]
    }
  },
  "/embedded-configs/:flowId/actions/enrollment/filters": {
    "name": "unused-embedEnrollmentPage1",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Enrollment filters loaded": [
        "FLOW_CONFIGS_CONTAINER",
        "ACTION_CONFIG_ENROLLMENT_FILTER_PANEL"
      ]
    }
  },
  "/embedded-configs/:flowId/actions/enrollment/reenrollment": {
    "name": "unused-embedRenrollmentPage",
    "success": {
      "No access": [
        "NO_ACCESS"
      ],
      "Reenrollment config loaded": [
        "FLOW_CONFIGS_CONTAINER",
        "ACTION_CONFIG_REENROLLMENT_PANEL"
      ]
    }
  },
  "/embedded-configs/:flowId/actions": {
    "name": "unused-embedAllActionsPage",
    "success": {
      "default": [
        "FLOW_CONFIGS_CONTAINER"
      ]
    }
  },
  "/embedded-configs/:flowId/actions/new-action": {
    "name": "unused-embedNewActionPage",
    "success": {
      "default": [
        "FLOW_CONFIGS_CONTAINER"
      ]
    }
  },
  "/embedded-configs/:flowId/actions/new-action/:actionType": {
    "name": "unused-embedNewActionPage1",
    "success": {
      "default": [
        "FLOW_CONFIGS_CONTAINER"
      ]
    }
  },
  "/embedded-configs/:flowId/actions/:actionId/email/editor": {
    "name": "unused-embedEmailEditorPage",
    "success": {
      "default": [
        "ACTION_CONFIG_PANEL",
        "FLOW_CONFIGS_CONTAINER",
        "FLOW_CONFIGS_EMAIL_EDITOR"
      ]
    }
  },
  "/embedded-configs/:flowId/actions/:actionId/email/editor/:emailId": {
    "name": "unused-embedEmailEditorPage1",
    "success": {
      "default": [
        "ACTION_CONFIG_PANEL",
        "FLOW_CONFIGS_CONTAINER",
        "FLOW_CONFIGS_EMAIL_EDITOR"
      ]
    }
  },
  "/embedded-configs/:flowId/actions/:actionId/:actionType": {
    "name": "unused-embedExistingActionPage",
    "success": {
      "default": [
        "FLOW_CONFIGS_CONTAINER",
        "ACTION_CONFIG_PANEL"
      ]
    }
  }
};